// extracted by mini-css-extract-plugin
export var errorIcon = "_mh-1";
export var nameLogo = "_mh-0";